import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import usePricing, { priceLine, depositLine } from '../../hooks/usePricing';

const PICKS = ['site-devops', 'growth', 'cto'];

// The committed colour field: cobalt owns this whole region. Three entry
// points from the live catalog, then the deposit rule.
export default function PricingTeaser() {
  const { byId, meta } = usePricing();
  const plans = PICKS.map((id) => byId[id]).filter(Boolean);
  return (
    <section className="bg-cobalt text-cream">
      <div className="container-x py-16 md:py-24">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <h2 className="reveal display-lg max-w-[14ch]">Prices on the page. No call required.</h2>
          <Link to="/pricing" className="reveal inline-flex items-center gap-2 text-cream/80 hover:text-cream">Full price list <ArrowRight className="h-4 w-4" /></Link>
        </div>
        <div className="mt-10 grid gap-px overflow-hidden rounded-2xl bg-white/15 md:grid-cols-3">
          {plans.map((p) => (
            <Link key={p.id} to={'/pricing#' + p.id} className="reveal group bg-cobalt p-8 transition-colors hover:bg-[#2559e6]">
              <p className="text-sm text-cream/70">{p.name}</p>
              <p className="price mt-3 text-4xl md:text-5xl">{priceLine(p)}</p>
              <p className="mt-2 text-sm text-cream/70">{depositLine(p, meta.depositPercent) || (p.billing === 'monthly' ? 'Cancel any month' : p.description)}</p>
              <p className="mt-6 text-sm text-cream underline-offset-4 group-hover:underline">See what is included</p>
            </Link>
          ))}
        </div>
        <p className="reveal mt-8 text-sm text-cream/70">Every fixed-price build: 50% to start, 50% when it ships. Postify, FillAI and ValidMy.email customers get a discount code.</p>
      </div>
    </section>
  );
}
